import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useSocket } from '@/contexts/SocketContext';
import { agentAPI } from '../api/agent.api';

export const useAgentStats = () => {
  const queryClient = useQueryClient();
  const { socket } = useSocket();

  const { data, isLoading, error } = useQuery({
    queryKey: ['agent-stats'],
    queryFn: () => agentAPI.getStats(),
    staleTime: 15000,
    gcTime: 60000,
  });

  useEffect(() => {
    if (!socket) return;

    const handleUpdate = () => {
      queryClient.invalidateQueries({ queryKey: ['agent-stats'] });
    };

    socket.on('agent:stats:updated', handleUpdate);

    return () => {
      socket.off('agent:stats:updated', handleUpdate);
    };
  }, [socket, queryClient]);

  return {
    stats: data?.data || { pending_count: 0, validated_today: 0, executed_month: 0, cancelled_today: 0 },
    isLoading,
    error,
  };
};
